import { AxiosRequestConfig } from "axios";
import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateTranslationModel } from "../../models/translations/CreateTranslationModel";
import { UpdateTranslationModel } from "../../models/translations/UpdateTranslationModel";

const RESOURCE_NAME = "tablemapping";

const getAllTranslation = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getAllTranslations`, requestConfig());
};

const downloadTranslations = (model: any) => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();
  config.responseType = "blob";

  return http.get(
    `${RESOURCE_NAME}/downloadTranslations?groupCode=${model.groupCode}&attribute=${model.attribute}`,
    config
  );
};

const uploadTranslations = (model: any) => {
  const http = getAxiosInstance();
  const formData = new FormData();
  formData.append("file", model.file);
  formData.append("groupCode", model.groupCode);
  formData.append("attribute", model.attribute);

  return http.post(
    `${RESOURCE_NAME}/uploadTranslations`,
    formData,
    requestConfig()
  );
};

const createTranslation = (model: CreateTranslationModel) => {
  const http = getAxiosInstance();
  return http.post(
    `${RESOURCE_NAME}/CreateTranslation`,
    model,
    requestConfig()
  );
};

const updateTranslation = (model: UpdateTranslationModel) => {
  const http = getAxiosInstance();
  return http.put(
    `${RESOURCE_NAME}/UpdateTranslation/${model.id}`,
    model,
    requestConfig()
  );
};

const deleteTranslation = (translationId: number) => {
  const http = getAxiosInstance();
  return http.delete(
    `${RESOURCE_NAME}/deleteTranslation/${translationId}`,
    requestConfig()
  );
};

const deleteTranslations = (groupCode: string, attribute: string) => {
  const http = getAxiosInstance();
  let url = `${RESOURCE_NAME}/deleteTranslations?attribute=${attribute}`;
  
  if (groupCode) {
    url += `&groupCode=${groupCode}`
  }

  return http.delete(
    url,
    requestConfig()
  );
};

const TranslationService = {
  getAllTranslation,
  downloadTranslations,
  uploadTranslations,
  createTranslation,
  updateTranslation,
  deleteTranslation,
  deleteTranslations,
};
export default TranslationService;
